<i18n lang='yml' src='../i18n/ExamBookIndex.yml'></i18n>
<template>

	<div class="inventory_item">
    <div class="heading-block mb-0 d-flex">
      <h4 v-if="examDetails && examDetails.name">
        {{ $t('header') }}
      </h4>    
      <a v-if="full_admin == 'true'" class="btn btn-sm btn-success ml-auto" href="inventory_items/new">
        <font-awesome-icon :icon="['fas', 'plus']"/>
        {{ $t('new_inventory') }}
      </a>      
    </div>
    <flash :message_type="message_type" :message_text="message_text"/>

    <div class="header-block mb-2">
      <div class="post-meta" v-if="examDetails && examDetails.name">  
        <h5 class='ml-2'>
          {{examDetails.test_id}} - {{ $t('version_text')}} {{examDetails.version_name}} - {{ examDetails.name[locale] }} <span v-if="examDetails.inter_provincial_exam"> - {{ $t('inter_provincial')}} </span>
        </h5>
     
        <ul class="list-inline list-annotation">         
          <li class="list-inline-item">
            <span class="status-bold">
              {{$t('exam_type_name')}}
            </span>
            {{examDetails.exam_type.name[locale]}} 
          </li>

          <li class="list-inline-item">
            <span class="status-bold">
              {{$t('current_inventory')}}
            </span>
            {{current_count}}         
          </li>  
          <li class="list-inline-item">
            <span class="status-bold">
              {{$t('available_inventory')}}
            </span>
            {{available_count}}  
          </li>
        </ul>
      </div>
      <div class="post-meta inventory-action-row">
        <div class="row">  
          <div class="inventory-dropdown col-md-12">   
            <Form ref="bulk_observer" class="w-100" v-slot="{ errors }" @submit="submitBulkLocationStatusChange($event)">
                <fieldset>
                  <div class="row">
                    <div class="form-group col-md-12 col-lg-10">
                      <div class="row">
                        <div class="form-group col-sm-12 col-md-6">
                          <Field
                            v-slot="{ errors, field }"
                            :name="$t('apply_status')"
                            rules="required" 
                          >
                            <div
                              for="status_change"
                              :class="[{'is-invalid': errors[0]}, `status_selector status_selector_${locale}`]"
                            >
                              <label for="status">
                                {{$t('apply_status')}}            
                              </label>
                              <!-- we need a seperate value so that i can validate on the front end  -->
                              <multi-select
                                :options="inventoryItemStatuses"
                                v-bind="field" 
                                :class="{'is-invalid': errors[0]}" 
                                searchable="true"
                                class="single-select"
                                :can-deselect="false"
                                :placeholder="$t('select_status_placeholder')"                   
                                v-model="selectedStatusForBulk" 
                                label="name"
                                key="value"
                              />
                            </div>
                            <div class="invalid-feedback" :class="`invalid-feedback_status_${locale}`"
                              v-if="errors[0]">
                              <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                              <span>{{ errors[0] }}</span> 
                            </div>
                          </Field>
                        </div>         
                        <div class="form-group col-sm-12 col-md-6" v-if="selectedStatusForBulk && selectedStatusForBulk == 'sent'">
                          <Field
                            v-slot="{ errors, field }"
                            :name="$t('to')"
                            rules="required"
                            v-model="toSelectedContainer"
                          >
                          <div
                            label="location"
                            :class="[{'is-invalid': errors[0]}, 'to_select_status']"
                          >
                            <label for="location-to-send"> 
                              {{$t('to')}} 
                            </label>
                            <multi-select
                              class="to_selector"
                              :options="getContainers(dropDownContainers)"
                              v-bind="field"
                              :class="{'is-invalid': errors[0]}"
                              searchable="true"
                              v-model="toSelectedContainer"
                              label="name"
                              valueProp="value"
                            />        
                          </div>
                          <div class="invalid-feedback invalid-feedback_location" v-if="errors[0]">
                            <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                            <span>{{ errors[0] }}</span> 
                          </div>
                          </Field>
                        </div>
                      </div>
                      <div class="row">
                        <span class="comments_section">
                          <label :class="`comment_label_${locale}`" for="bulkComment">{{ $t('comments.label') }}</label>
                          <textarea class="textareaComments" id="bulkComment" v-model="bulkComment" cols="50"/>
                        </span>
                      </div>
                  
                    </div>
                    <div class="col-sm-12 col-lg-2">
      
                      <div class="submit_status">  
                        <button class="btn btn-sm btn-wide btn-success" :class="{ 'disabled': bulkUpdateInventoryItems.length == 0}" href="#" type="submit">
                          {{ $t('save') }} 
                        </button>
                      </div>
                    </div>
                  </div>
                </fieldset>
            </Form>  
          </div> 
        </div>
      </div>
    </div>
    <filter-bar :filter_params="filter_params" :filter_path ="base_path"></filter-bar>
    <div class="d-flex mb-4 selectedAlert">
      <div class="btn-group ml-2 ml-auto">
        <div v-if="bulkUpdateInventoryItems.length && selectableItems.length > 0">
          <span class="book_count">{{bulkUpdateInventoryItems.length}}</span> 
          {{bulkUpdateInventoryItems.length > 1 ? $t('exam_books') : $t('exam_book')}} {{$t('selected')}}
        </div>
        <button v-if='bulkUpdateInventoryItems.length == 0'  class="btn btn-outline-secondary" href="#" @click="selectAll">
          {{ $t('select_all') }}
        </button>
        <button v-else class="btn btn-outline-secondary" href="#" @click="deselectAll">
          {{ $t('deselect_all') }}
        </button>
      </div>
    </div>  
      
    <div v-if="inventoryItems.length > 0">
      <div class="content-block" v-for="item in items" :key="item.id">
        <div class="post-meta">
          <ul class="list-inline list-annotation">
            <li>
              <h5 class="container-item-name">
              {{$t('control_number')}} {{ item.code }}
              </h5>
            </li>
            <li v-if="editable(item)" class="list-inline-item ml-auto" >
              <label class="check-select">
                <input :id="`item-${item.id}`" v-model="bulkUpdateInventoryItems" type="checkbox" :value="item" /> 
                <span>{{ $t('select') }}</span>
              </label>
            </li>
          </ul>
        </div>
     
        <div class="post-meta">
          <ul class="list-unstyled list-inline list-annotation">
            <li class="list-inline-item">
              <span>
                {{$t('location')}}:
              </span>
              <span class="status-badge">
                {{ item.container ? item.container.translated_name : $t('root')}}
              </span>
            </li>
          </ul>
          <ul class="list-unstyled list-inline list-annotation">

            <li class="list-inline-item">
              <span>
                {{$t('status')}}
              </span>

              <span class="status-badge"> 
                {{$t(item.status)}}
              </span>
           
            </li>
          
            <li class="list-inline-item">
              <span>
                {{$t('status_date')}}:
              </span>
              <span class="status-badge">
                {{formatDate(item.updated_at)}}
              </span>
            </li>
          </ul>

        </div>  
        <div class="post-tabs">
          <ul class="nav nav-tabs nav-tile" role="tablist">
            <li v-if="editable(item)" class="nav-item">
              <a class="nav-link" :href="`#status-${item.id}`">
                <font-awesome-icon :icon="['fas', 'cog']" />
                <span>{{$t('change_status')}}</span>
              </a>
            </li>
            <li class="nav-item d-lg-none">
              <a class="nav-link" :href="`#info-${item.id}`">
                <font-awesome-icon :icon="['fas', 'info-circle']" />
                <span> {{$t('more_info')}}</span>
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" :href="`#history-${item.id}`">
                <font-awesome-icon :icon="['fas', 'history']" />
                <span>{{$t('history')}}</span>
              </a>
            </li>
          </ul>
        <div class="tab-content">
          <div class="tab-pane" v-if="editable(item)" :id="`status-${item.id}`">
            <Form :ref="`observer-${item.id}`" v-slot="{ errors }" @submit="submitLocationStatusChange(item)">
                <fieldset>
                  <div class="row">
                    <div class="form-group col-md-12 col-lg-10">
                      <div class="row">
                        <div class="form-group col-md-12 col-lg-6">
                          <Field
                            v-slot="{ errors, field }"
                            :name="`${$t('apply_status')}_${item.id}`"
                            rules="required" 
                          >
                          <div
                            :for="`status_change_${item.id}`"
                            :class="{'is-invalid': errors[0]}" 
                            >
                            <label :for="`status_change_${item.id}`"> 
                            {{$t('apply_status')}} 
                          </label>
                            <multi-select   
                              :options="filterOptions(inventoryItemStatuses,item.status)"
                              v-bind="field" 
                              :class="{'is-invalid': errors[0]}" 
                              searchable="true"
                              class="single-select"
                              :placeholder="$t('select_status_placeholder')"                   
                              v-model="item.selectedStatus" 
                              label="name"
                              key="value"
                            />
                            </div>
                            <div class="invalid-feedback" id="inter_provincial_exam_error" v-if="errors[0]">
                              <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                              <span>{{ errors[0].replace(/_\d+/, '')}} </span> 
                            </div>
                          </Field>
                        </div>
                        <div class="form-group col-md-12 col-lg-6" v-if="item.selectedStatus && item.selectedStatus == 'sent'">
                          <Field
                            v-slot="{ errors, field }"
                            :name="`${$t('to')}-${item.id}`"
                            rules="required"
                            v-model="item.selectedContainer"
                          >
                          <div
                            label="location"
                            label-for="location"
                            :class="{'is-invalid': errors[0]}" 
                          >
                            <label :for="`location-${item.id}`"> 
                              {{$t('to')}} 
                            </label>
                            <multi-select
                              :options="filterOptions(getContainers(dropDownContainers), item.container_id)"
                              :class="{'is-invalid': errors[0]}"
                              searchable="true"
                              label="name"
                              valueProp="value"
                              :placeholder="$t('select_placeholder')"
                              v-model="item.selectedContainer"
                            />
                          </div>
                          <div class="invalid-feedback" id="inter_provincial_exam_error" v-if="errors[0]">
                            <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                            <span>{{ errors[0].replace(/-\d+/, '')}} </span> 
                          </div>
                          </Field>
                        </div>
                      </div>
                       <label class="w-100" :for="`location_comment_${item.id}`">{{ $t('comments.label') }}</label>
                      <textarea class="w-100 textareaComments" :id="`location_comment_${item.id}`" v-model="item.comment" cols="50"/>
                    </div>
                    <div class="col-sm-12 col-lg-2">
                      <button class="btn btn-sm btn-success save-apply-status"  type="submit" href="#" >
                        {{ $t('save') }}
                      </button>
                    </div>
                  </div>
                </fieldset>
            </Form>   
          </div>    
          <div class="tab-pane" :id="`info-${item.id}`">
            <ul class="exam-details mb-0"> 
              <li>
                <span class="status-bold">
                  {{$t('exam_name')}}
                </span>
                {{item.inventoryable.name[locale]}}
              </li>
              <li>
                <span class="status-bold">
                  {{$t('exam_test_id')}}
                </span>
                {{item.inventoryable.test_id}}
              </li>
        
              <li>
                <span class="status-bold">
                  {{$t('exam_version')}}
                </span>
                {{item.inventoryable.version_name}}
              </li>
            
              <li >
                <span class="status-bold">
                  {{$t('exam_type_name')}}
                </span>
                {{item.inventoryable.exam_type.name[locale]}}
              </li>
            </ul>
          </div>
          <div class="tab-pane" :id="`history-${item.id}`">
            <history-table :locale="locale" :pagination_limit="pagination_limit" name="inventory" :top_id="`history-${item.id}`" :itemData="tableData(item)" :column_info="columnData()" :needsPagination="true"/>
          </div>
        </div>
        </div>
      </div>
    </div>
    <div v-if="inventoryItems.length == 0">
      <div class="alert alert-warning" role="alert">
        {{ $t('no_data') }}
      </div>
    </div>
    <pagination v-if="totalInventoryItems" 
      @items_changed="setItems" 
      :items="totalInventoryItems" 
      :pagination_limit="pagination_limit"
      :expansion_threshold="expansion_threshold" 
    />
  </div>
</template>
<script>
import Main from '../../../../filter_bar/components/Main.vue';
import Pagination from '../../../../shared/pagination/Pagination.vue';
import Flash from '../../../../shared/flash_messages/components/Flash.vue';
import Table from '../../../../shared/table/components/Table.vue'
import '../../../../../javascripts/application/vee-validate-rules.js'
import { sendAjaxRequest, ajaxResponseMessage } from '../../../../shared/typescripts/ajax.ts'
import { Form, Field } from 'vee-validate'
import { formatDate } from '../../../../shared/typescripts/dates.ts'

export default {
  props: [
    'locale',
    'filter_params',
    'base_path',
    'inventory_items',
    'inventory_item_statuses',
    'containers_with_inventory',
    'pagination_limit',
    'exam_details',
    'full_admin',
    'editable_containers',
    'current_count',
    'available_count',
    'expansion_threshold'
    ],

  components: {
    'filter-bar': Main,
    'pagination': Pagination,
    'flash': Flash,
    'history-table': Table,
    Form,
    Field
  },

  data() {
    return {
      loading: false,
      error: false,
      filterParams: null,
      bulkComment: null,
      inventoryItems: [{inventoryable: {name: {}, exam_type: {name: {}}}}],
      bulkUpdateInventoryItems: [],
      selectedStatusForBulk: null,
      toSelectedContainer: null,
      isAllSelected: false,
      inventoryItemStatuses: [],
      dropDownContainers: [],
      inventoryItemsPageCount: Number(this.inventory_items_page_count),
      message_text: [],
      message_type: "",
      ExamTabName: this.$i18n.t('exam_tab_label'),
      inventoryItems: [],
      totalInventoryItems: [],
      examDetails: [],
      editableContainerIDs: [],
      options: ['list', 'of', 'options'],
      selected: null,
      items: [],
    }
  },

  created() {
    this.loading = true
    this.$i18n.locale = this.locale;
    this.filterParams = this.filter_params
    
    try{
      this.inventoryItems = JSON.parse(this.inventory_items)
      this.totalInventoryItems = JSON.parse(this.inventory_items)
      this.totalInventoryItems.map((item) => {
        // We need to set these values here otherwise if we use v-model on them it will trigger a scroll to the top of the page when they first change
        item.selectedContainer = null
        item.selectedStatus = null
        item.comment = ""
        item.versions.reverse()
      })
      this.inventoryItemStatuses = JSON.parse(this.inventory_item_statuses || []);
      this.dropDownContainers = JSON.parse(this.containers_with_inventory || []);
      if (this.exam_details) {
        this.examDetails = JSON.parse(this.exam_details)
        if(this.full_admin == 'false') {
          this.editableContainerIDs = JSON.parse(this.editable_containers)
        }
      }
    }
    catch(err){
      this.error = true
    }
  },
  computed: {
    selectableItems(){
      return this.totalInventoryItems.filter((item) => {return this.editableContainerIDs.includes(item.container_id)})
    },
  },

  methods: {
    filterOptions (data, string) {
      return data.filter(function(el) { return el.value != string; }) ;
  },
  getContainers(data,) {
    let newArray = [];
    data.map((item) => {
      newArray.push({value: item.id, name: item.label})
    })
    return newArray
  },
    editable(item) {
      let container = item.container ? item.container.id : -1
      return this.full_admin == 'true' || this.editableContainerIDs.includes(container)
    },
    // For each item row in the table, pulls out the data necessary from the item and stores it in keys that are referenced in columnData function
    tableData(item) {
      return item && item.versions.length > 0 ? item.versions.map((version) => {
        return {
          created_at: version.created_at, 
          full_name: version.user_identity ? `${version.user_identity.first_name} ${version.user_identity.last_name}` : '',
          status: version.changed_to && version.changed_to.status ? this.$i18n.t(version.changed_to.status) : this.$i18n.t(version.event),
          new_location: version.current_container ? version.current_container.translated_name : this.$i18n.t('root'),
          prev_location: version.previous_container ? version.previous_container.translated_name : this.$i18n.t('root'),
          comments: version.changed_to ? version.changed_to.comment : ''
        }
      }) : []
    },
    // Returns an array of objects, each representing a column in the table with a column name, a key for the attribute it pulls from and a format type
    columnData() {
      let columns = [
        {name: this.$i18n.t('date'), key: 'created_at', formatType: 'date'},
        {name: this.$i18n.t('changed_by'), key: 'full_name'},
        {name: this.$i18n.t('status_applied'), key: 'status'},
        {name: this.$i18n.t('prev_location'), key: 'prev_location' },
        {name: this.$i18n.t('new_location'), key: 'new_location' },
        {name: this.$i18n.t('history_comments'), key: 'comments', fullLength: true }
      ]
      return columns
    },
    formatDate(dateString) {
      return formatDate(dateString)
    },
    shouldDisable(status, item) {
      return (status.name=='received' && item.status != 'sent') 
    },
    getContainerId(status, toContainer) {
      switch(status) {
        case "recalled" || "removed":
          return null
        case 'sent':
          return toContainer
      }
     },
    async submitLocationStatusChange(item){
      let valid = await this.validate(this.$refs[`observer-${item.id}`][0])
      if (!valid || !this.recallConfirmation(item.selectedStatus) || !this.removeConfirmation(item.selectedStatus)) {
        return
      }
      item.container_id = this.getContainerId(item.selectedStatus,  item.selectedContainer) 
      item.status = item.selectedStatus
      var data = {  
        inventory_item: item
      }
      this.loading = true
      this.message_text = [];
      this.message_type = ''

      await sendAjaxRequest('PUT', `${this.base_path}/${item.id}`, 'json', data, ajaxResponseMessage, this.throwError);
    },
    async submitBulkLocationStatusChange() { 
      let valid = await this.validate(this.$refs['bulk_observer'])     
      if (!valid || !this.recallConfirmation(this.selectedStatusForBulk) || !this.removeConfirmation(this.selectedStatusForBulk)) {
        return
      }
      let changeContainerIdStatuses = ['sent', 'recalled', 'removed']
      var data = { 
        inventory_item_id_array:  this.bulkUpdateInventoryItems.map((item) => {return item.id}),
        
        inventory_item: {  
          comment: this.bulkComment,
          status: this.selectedStatusForBulk,   
        }
      }
      if(changeContainerIdStatuses.includes(this.selectedStatusForBulk))
      {
        data.inventory_item.container_id = this.getContainerId(this.selectedStatusForBulk, this.toSelectedContainer)
      }
      this.loading = true
      this.message_text = [];
      this.message_type = ''

      await sendAjaxRequest('POST', 'inventory_items/bulk_update', 'json', data, ajaxResponseMessage, this.throwError);
    },

    validate(ref) {
      return ref.validate().then(function (result) { return result }).catch( error =>  console.log(error) );
    },

    recallConfirmation(status) {
      if (status =='recalled') {
        return confirm(this.$t('recall_confirm'))
      }
      return true
    },
    removeConfirmation(status) {
      if (status =='removed') {
        return confirm(this.$t('remove_confirm'))
      }
      return true
    },  
    scrollToTop: function() {
      window.scrollTo({top: 0, behavior: 'smooth'});
    },
    selectAll(e) {
      e.preventDefault();
      this.totalInventoryItems.forEach((item) => {
        if(this.bulkUpdateInventoryItems.indexOf(item) == -1) {
          this.bulkUpdateInventoryItems.push(item);
        }
      })
    },
    deselectAll(e) {
      e.preventDefault();
      this.bulkUpdateInventoryItems = [];
    },
    setItems(items) {
      this.items = items
    },

    throwError() {
      console.log("Error")
    }

  }
}
</script>
